<template>
  <div>
    <StandardCard v-if="profile" :title="profile.contact.name" subheader="INFO">
      <template v-slot:dialogBtn>
        <v-list-item-icon v-if="profile.isMainContactPerson">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click.stop="editProfile = true" fab small>
                <v-icon>mdi-account-edit</v-icon>
              </v-btn>
            </template>
            <span>Endre profil</span>
          </v-tooltip>
        </v-list-item-icon>
      </template>

      <template v-slot>
        <CardContent v-model="companyInfo" />
      </template>
    </StandardCard>
    <EditCompanyDialog v-model="editProfile" :profile="profile" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";
import EditCompanyDialog from "@/components/company/children/EditCompanyDialog.vue";

export default Vue.extend({
  name: "CompanyCard",
  data() {
    return {
      editProfile: false,
    };
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
    companyInfo() {
      var contact = this.profile.contact;
      var data = [
        {
          icon: "mdi-card-account-details-star",
          title: "Hovedkontaktperson",
          content: contact?.mainContactPersonName,
        },
        {
          icon: "mdi-cellphone",
          title: "Mobil",
          content: contact?.mobile,
        },
        {
          icon: "mdi-phone-in-talk-outline",
          title: "Telefon",
          content: contact?.phone,
        },
        {
          icon: "mdi-web",
          title: "Web",
          content: contact?.www,
        },
        {
          icon: "mdi-folder-pound-outline",
          title: "Org.nr",
          content: contact?.regNum,
        },
        {
          icon: "mdi-map-marker-outline",
          title: "Adresse",
          content: contact?.address,
        },
        {
          icon: "mdi-truck-delivery-outline",
          title: "Postnr/sted",
          content: contact?.postCode?.display,
        },
      ];

      return data;
    },
  },
  components: {
    StandardCard,
    CardContent,
    EditCompanyDialog,
  },
});
</script>
